import { render, staticRenderFns } from "./LikerItem.vue?vue&type=template&id=c090dc90&"
import script from "./LikerItem.vue?vue&type=script&lang=js&"
export * from "./LikerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports